var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_398",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28866",
    "data-name": "Group 28866",
    transform: "translate(-4710 6237)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 4710, -6237)",
    filter: "url(#Ellipse_398)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_398-2",
    "data-name": "Ellipse 398",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_1_",
    "data-name": "svgexport-17 (1)",
    transform: "translate(4729 -6218)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49741",
    "data-name": "Path 49741",
    d: "M17.516,74.781,0,55.348l6.085-9.071H28.678l6.074,9.054Z",
    transform: "translate(0 -46.277)",
    fill: "#ff3997"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49742",
    "data-name": "Path 49742",
    d: "M257.828,74.776l17.23-19.445-6.073-9.054H257.828Z",
    transform: "translate(-240.307 -46.277)",
    fill: "#d6298c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49743",
    "data-name": "Path 49743",
    d: "M0,179.767,17.516,199.2,34.7,179.805Z",
    transform: "translate(0 -170.696)",
    fill: "#ff5ca8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49744",
    "data-name": "Path 49744",
    d: "M257.828,180.05v19.408l17.182-19.389Z",
    transform: "translate(-240.307 -170.959)",
    fill: "#ff3997"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49745",
    "data-name": "Path 49745",
    d: "M158.938,199.721l-7.206-19.394H165.9Z",
    transform: "translate(-141.421 -171.218)",
    fill: "#ff3997"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49746",
    "data-name": "Path 49746",
    d: "M24.482,55.386H10.311l7.21-9.109,6.961,9.109ZM0,55.348l10.311.038L6.085,46.277Z",
    transform: "translate(0 -46.277)",
    fill: "#d6298c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49747",
    "data-name": "Path 49747",
    d: "M370.579,55.348l-10.311.038,4.226-9.109Z",
    transform: "translate(-335.786 -46.277)",
    fill: "#ff5ca8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49748",
    "data-name": "Path 49748",
    d: "M257.828,180.327v19.382l6.961-19.382Z",
    transform: "translate(-240.307 -171.218)",
    fill: "#d6298c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49749",
    "data-name": "Path 49749",
    d: "M257.828,46.278v9.109h6.961ZM275.1,55.348l-10.311.038,4.226-9.109Z",
    transform: "translate(-240.307 -46.277)",
    fill: "#bf1b81"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.328846f78d245e67b328c14776eb0312.svg";
export { ForwardRef as ReactComponent };